import { render } from "./chMedicinePhys.vue?vue&type=template&id=2f187ff6"
import script from "./chMedicinePhys.vue?vue&type=script&lang=js"
export * from "./chMedicinePhys.vue?vue&type=script&lang=js"

import "./chMedicinePhys.vue?vue&type=style&index=0&id=2f187ff6&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__